import script from "./LiveCasinoGames.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCasinoGames.vue?vue&type=script&setup=true&lang=js"

import "./LiveCasinoGames.vue?vue&type=style&index=0&id=b32969de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b32969de"]])

export default __exports__